import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { SettingsCustomFormsService, SettingsCustomFormsEditorService } from '@app/services/settings/custom-forms.service';
import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";

import { Form } from '@core/objects/form';
import { FieldDataInterface } from '@core/custom-forms/models/settings/settings-custom-form-field-data.model';


import { FormsFieldItemMenuClick } from '@core/custom-forms/components/settings-field-menu/field-menu-item.model';
import { EditingForm } from '@app/store/state/settings/custom-forms/custom-forms.state';
import { FieldFactoryLocator } from '@core/custom-forms/factories/field-factory-locator';


@Component({
    selector: 'settings-forms-form-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsFormsFormMainComponent implements OnInit, OnDestroy  {

	public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

    @Input() currentForm: EditingForm;

	@Output() cancel = new EventEmitter<boolean>();
	@Output() submit = new EventEmitter<Form>();

	public status: number = this.STATUS_LOADING;
    public initialized: boolean = false;
    public changesPending: boolean;

    public currentFields: Array<SettingsCustomFormFieldData>;
    public buttonDisabled: boolean = false;

	// public selectedEvent: any = '';
	// public saveBtntext: string = 'Save';

    public formReady: boolean = false;
    public fieldsReady: boolean = false;

    protected description: string = "";
    public menuFields: Array<ThreeDotsMenuItem> = [
        // {
        //     title: "Add a new field",
        //     key: "add-field",
        //     icon: "add",
        //     order: 1
        // }
    ];
    private removing: FieldDataInterface = null; // TODO: in future to double check with really menu item to remove field!!
	private subs: Subscription[] = [];

	constructor(public formsSrv: SettingsCustomFormsService, 
        private formsEditorSrv: SettingsCustomFormsEditorService,
        private fieldFactoryLocator: FieldFactoryLocator,
        private cdr: ChangeDetectorRef){}

	ngOnInit(){
        this.buildMenu();

        this.subs.push(
            this.formsEditorSrv.selectEditingActiveFields().subscribe((fieldIntances: Array<SettingsCustomFormFieldData>) => {
                this.currentFields = fieldIntances;
                // check on each update if fields are ready
                // ready in fields where we need to check in settings more than label filled.
                this.fieldsReady = !fieldIntances.some((cf: SettingsCustomFormFieldData) => cf.label == '' || (('ready' in cf) && !cf.ready ));
                this.initView();
            })
        );   


        this.subs.push(
            this.formsEditorSrv.selectEditing().subscribe((editing: EditingForm) => {
                this.changesPending = editing.modified;
                this.buttonDisabled = !editing.modified
            })
        );

        this.subs.push(
            this.formsSrv.selectStarting().subscribe((starting: any) => {
                this.initialized = starting.initialized_forms && (starting.initialized_fields || !this.currentForm.form.id);
                this.initView();
            })
        ); 

        this.initView();
    }

    ngOnDestroy() {
        // Unsubscribe from all subscriptions
        this.subs.forEach((sub: Subscription) => sub.unsubscribe());
    }

    initView(){
        if(this.currentForm && this.currentFields && this.initialized){
            this.status = this.STATUS_DONE;
        } 
    }

	onCancel() {
        this.cancel.emit(true);
	}

    onSubmit(){
        if(this.currentForm?.form.name == '' || !this.fieldsReady)
            return;

        // this.saveBtntext = "Saving...";
        this.buttonDisabled = true;

        this.submit.emit(this.currentForm.form);
    }

    onFormNameChange(name: string) {
        this.buttonDisabled = name.trim() === '';  // avoid save action when blank name
        this.formsEditorSrv.setName(name);
    }

    onFieldChange(field: SettingsCustomFormFieldData){

        this.buttonDisabled = false;
        this.formsEditorSrv.setField(field);
    }

    onMainMenuClick(type: string) {
        //  manage the new type to add:
        this.formsEditorSrv.addField(type);
    }

    onFieldMenuClick(fieldMenuItem: FormsFieldItemMenuClick) {
        switch(fieldMenuItem.key) {
            case 'move-up':
                this.moveUp(fieldMenuItem.field);
                break;
            case 'move-down':
                this.moveDown(fieldMenuItem.field);
                break;
            // this will be managed in the component to display really menu item
            // case 'remove':
            //     this.reallyRemoveField(fieldMenuItem.field);
            //     // this.removeField(fieldMenuItem.field);
            //     break;
            case 'really-remove':
                this.reallyRemoveField(fieldMenuItem.field);
                break;
            default:
                console.log(" fieldMenuItem cliked NO ACTION YET", fieldMenuItem);
        }
    }
    // https://material.angular.io/cdk/drag-drop/overview //
    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(this.currentFields, event.previousIndex, event.currentIndex);
        // Now calculate which fields have updated positions
        const updatedFields = this.getUpdatedPositionFields();

        // // Only send the fields that changed their position to the service
        if (updatedFields.length > 0) {
            this.formsEditorSrv.updateFieldPositions(updatedFields);
        }
        
    }

    private buildMenu(){
        this.menuFields = this.fieldFactoryLocator.findAvailableFactories().map((factory, index) => {
            return {
                title: factory.menuTitle,  // Use the menuTitle property from the factory
                key: factory.type,    // use the type as a key form the menu item
                icon: factory.type,   // use appropriate icon to display
                order: index + 1      // ordering for menu
            };
        });
        this.initView();
    }


    private moveUp(item: SettingsCustomFormFieldData){
        this.formsEditorSrv.moveFiedlUp(item);
    }

    private moveDown(item: SettingsCustomFormFieldData){
        this.formsEditorSrv.moveFiedlDown(item);
    }

    // the real action  to remove field
    private reallyRemoveField(field: SettingsCustomFormFieldData) {
        // ACTION to remove option form the list
        
        // this.emit({ ...this.field, active: false});
        this.formsEditorSrv.removeField(field);
    }

    // this track function should prevent loops on fields when display the content.
    protected trackByFn(index: number, field: SettingsCustomFormFieldData): number {
        return field.position; // some unique identifier
    }

    private getUpdatedPositionFields() {
        const updatedPFields = [];
    
        // Compare currentFields with originalFields to find out which ones have changed
        this.currentFields.forEach((field, index) => {
            if (field.position !== index) { // If the position has changed
                // Update the position of the field 
                const movedField = field.update({ position: index })
                updatedPFields.push(movedField);  // Add to the list of changed fields
            }
        });
    
        return updatedPFields;
    }

    /******** UTIL for old field types *********/
    // Keep this code in case we want to let user clean old fields with a discrd button

    // isFieldTypeValid(type: string): boolean {
    //     return Object.values(this.FIELD_TYPES).includes(type as CustomFormFieldTypes);
    // }
    // action button to make this field as removed if not anymore used.
    // onDiscard(field: FieldDataInterface){

    //     this.reallyRemoveField(field);
    // }



}
